module.exports = __webpack_public_path__ + "img/error-image.841c1dcb.png";